import { render } from "./FieldSettingsDialog.vue?vue&type=template&id=447522b9&scoped=true&lang=pug"
import script from "./FieldSettingsDialog.vue?vue&type=script&lang=js"
export * from "./FieldSettingsDialog.vue?vue&type=script&lang=js"

import "./FieldSettingsDialog.vue?vue&type=style&index=0&id=447522b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447522b9"]])

export default __exports__